import { Healthcheck, HEALTH_STATUS } from 'domain/shared/newProject';
import { StaffingRiskIssue } from 'domain/shared/staffing';

export const getHealthcheckByName = (healthChecks?: Healthcheck[], name?: string): Healthcheck | null => {
  if (!healthChecks || !Array.isArray(healthChecks)) {
    return null;
  }

  const healthcheck = healthChecks.find(check => check.name === name && check.status === HEALTH_STATUS.ACTIVE);

  return healthcheck || null;
};

export const getStaffingRiskIssueByName = (
  staffingRiskIssue?: StaffingRiskIssue[],
  name?: string,
): StaffingRiskIssue | null => {
  if (!staffingRiskIssue || !Array.isArray(staffingRiskIssue)) {
    return null;
  }

  const healthcheck = staffingRiskIssue.find(
    check => check.systemIssueType === name && check.status === HEALTH_STATUS.ACTIVE,
  );

  return healthcheck || null;
};
